import axios from 'axios'

const BASE_URL = import.meta.env.VITE_API_BASE_URL

function normalizeStripeError(error) {
  if (error?.response) {
    const apiMessage =
      error.response.data?.error?.message ||
      error.response.data?.message

    return {
      data: error.response.data,
      responseStatus: error.response.status,
      message: apiMessage || 'Erro ao criar sessão de checkout',
    }
  }

  return {
    data: null,
    responseStatus: 0,
    message: error?.message || 'Erro ao criar sessão de checkout',
  }
}

export const createCheckoutSession = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${BASE_URL}stripe/create-checkout-session`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const createGuestCheckoutSession = async (body) => {
  return await axios
    .post(`${BASE_URL}stripe/create-guest-checkout-session`, body)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      console.log('error createGuestCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const getAddonPackages = async (language) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .get(`${BASE_URL}stripe/addon-packages/${language}`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      return error
    })
}

export const createAddonCheckoutSession = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${BASE_URL}stripe/create-addon-checkout-session`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createAddonCheckoutSession', error.response?.data)
      return normalizeStripeError(error)
    })
}

export const createPortalSession = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem('token'))

  const config = {
    headers: {
      Authorization: 'Bearer ' + STORAGE_TOKEN,
    },
    withCredentials: true,
  }

  return await axios
    .post(`${BASE_URL}stripe/create-portal-session`, body, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      }
    })
    .catch(function (error) {
      if (error.response?.status === 401) {
        window.localStorage.clear()
        window.location.reload()
      }
      console.log('error createPortalSession', error.response?.data)
      return error
    })
}
